import { REVIEW_ORDER_STORAGE_KEY } from '../constants/checkout';

/**
 * Drops the checkout review page's refresh copy of an in-progress order (useReviewOrderState).
 *
 * The order belongs to the firm and site it was started on, so the copy must not outlive either: it
 * is cleared on logout and on every firm/site switch. Those navigate with a full page load, which
 * never unmounts the review page, so its own unmount cleanup doesn't run. Guarded: storage can be
 * blocked, and neither a logout nor a switch may fail because of it.
 */
export function clearReviewOrderCopy() {
  try {
    sessionStorage.removeItem(REVIEW_ORDER_STORAGE_KEY);
  } catch {
    // nothing kept, nothing to clear
  }
}
